import { render, staticRenderFns } from "./BancaEmaticaRichiestaScorteView.vue?vue&type=template&id=00630fc5"
import script from "./BancaEmaticaRichiestaScorteView.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaRichiestaScorteView.vue?vue&type=script&lang=js"
import style0 from "./BancaEmaticaRichiestaScorteView.vue?vue&type=style&index=0&id=00630fc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports